export default __webpack_public_path__ + "static/media/Breaking bad.5ee3d52a.jpg";